import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import PageSection from "../NIISPageSection/PageSection";
import ResponsivePageHeader from "../NIISResponsivePageHeader/ResponsivePageHeader";
import { Col, Row } from "react-bootstrap";
import CoursesMiniCard from "../NIISCoursesMiniCard/CoursesMiniCard";
import {informationScienceCourseData } from "../../static-data/informationsciencecourses.data";

const InformationScienceCoursesResponsive = () => {
  const [currentBreakPoint, setCurrentBreakPoint] = useState("");

  useEffect(() => {
    bsBreakpoints.init();
    setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

    const handleBreakPoint = (event) => {
      setCurrentBreakPoint(event.detail);
    };

    window.addEventListener("new.bs.breakpoint", handleBreakPoint);

    return () => {
      window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
    };
  }, []);

  const rowContainerClasses = classNames({
    "w-80 mx-auto": !(
      currentBreakPoint === "xSmall" || currentBreakPoint === "small"
    ),
  });

  return (
    <PageSection type="lg" bgClass="page-background-1">
      <ResponsivePageHeader title="Explore Our Courses" />

      <br />
      <div className={rowContainerClasses}>
        <Row className="justify-content-center gx-1">
          {informationScienceCourseData.map((data, index) => (
            <Col
              md="3"
              className="d-flex align-items-stretch mb-4 mb-md-0"
              key={"course-responsive" + index}
            >
              <CoursesMiniCard {...data} />
            </Col>
          ))}
        </Row>  
      </div>

      <br />

    </PageSection>
  );
};

export default InformationScienceCoursesResponsive;
